<template>
  <q-card square id="xyz" class="sticky-header-card">
    <div class="center-sticky-header">
      <vehicle-class-performance-sub-menu class="sticky-fully-v2">
        <template v-slot:activator>
          <div class="sticky-add">
            <q-btn color="green" size="sm" label="" icon="fas fa-plus"
                   @click="$router.push('/class-performances/batch')"></q-btn>
          </div>
        </template>
      </vehicle-class-performance-sub-menu>
      <div class="sticky-sub-menu">
        <div class="filter-info">
          Filters:
          <q-badge v-if="anyFilter" color="negative">NONE</q-badge>
          <q-badge style="margin-right:5px"
                   outline color="positive"
                   v-if="companyFilter && companyFilter.name">Company :
            {{ companyFilter && companyFilter.name ? companyFilter.name : '' }}
          </q-badge>
          <q-badge style="margin-right:5px" outline color="info" v-if="multiFilter > 0">Locations:{{
              multiFilter
            }}
          </q-badge>
          <q-badge style="margin-right:5px" outline color="warning" v-if="search">Search: {{ search }}</q-badge>
        </div>
        <div class="sticky-add">
          <q-btn round @click="$store.commit('vehicleClassPerformance/SET_VEHICLE_OPERATION', true)"
                 color="red" size="xs">
            <q-icon name="fas fa-plus" style="margin-top:3px"></q-icon>
          </q-btn>
        </div>

        <q-icon
          color="grey-7"
          @click="subMenu = true"
          name="fas fa-caret-down"
          class="cursor-pointer"
          size="25px"
        ></q-icon>

        <q-dialog v-model="subMenu" persistent transition-show="scale" transition-hide="scale">
          <q-card style="width: 300px">
            <div class="bg-primary text-white sub-menu-title">
              <div class="text-h6">Filters</div>

              <q-icon @click="subMenu = false" name="fas fa-times" class="cursor-pointer"></q-icon>
            </div>
            <vehicle-class-performance-sub-menu class="sub-menu-filters">
              <template v-slot:activator>
                <div class="row">
                  <q-btn
                    label="Close"
                    size="md"
                    @click="subMenu = false"
                    color="negative"
                    style="width:calc(50% - 5px);margin-right:5px"
                  ></q-btn>
                  <q-btn
                    size="md"
                    label="RESET"
                    color="primary"
                    :disable="anyFilter"
                    style="width:calc(50%)"
                    @click="
                      $store.commit('vehicleClassPerformance/RESET_FILTER', true)
                      subMenu = false
                    "
                  ></q-btn>
                </div>
              </template>
            </vehicle-class-performance-sub-menu>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </q-card>
</template>

<script>
import VehicleClassPerformanceSubMenu from './VehicleClassPerformanceSubMenu.vue'
import axios from '../axios/index'

export default {
  components: {
    VehicleClassPerformanceSubMenu
  },
  data() {
    return {
      subMenu: false
    }
  },
  async mounted() {
    if (this.$store.state.company.companies.length === 0) await this.getCompanies()
  },
  methods: {
    async getCompanies() {
      const {data} = await axios.get('companies')
      this.companies = data.data
    }
  },
  computed: {
    drawer() {
      return this.$store.state.layout.drawer
    },
    anyFilter() {
      return !((this.companyFilter && this.companyFilter.name) || this.multiFilter > 0 || this.search);
    },
    search() {
      return this.$store.state.vehicleClassPerformance.search
    },
    companyFilter() {
      return this.$store.state.vehicleClassPerformance.companyFilter
    },
    multiFilter() {
      return this.$store.state.vehicleClassPerformance.multiFilter.length
    },
    grid: {
      get() {
        return this.$store.state.vehicleClassPerformance.grid
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_GRID_TYPE', val)
      }
    },
    companies: {
      get() {
        return this.$store.state.company.companies
      },
      set(val) {
        this.$store.commit('company/SET_USER_COMPANIES', val)
      }
    },
    selectedVehicles: {
      get() {
        return this.$store.state.vehicleClassPerformance.selectedVehicles
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_SELECTED_VEHICLES', val)
      }
    }
  }
}
</script>

<style lang="scss">
.sticky-fully-v2 {
  display: flex;
  align-items: center;
  margin: 0 18px;
  flex: 0 1 calc(100% - 18px);

  .sticky-select {
    flex: 0 1 20%;
  }

  .sticky-search {
    margin-left: 5px;
    flex: 0 1 20%;
  }

  .sticky-location {
    margin-left: 5px;
    flex: 0 1 20%;
  }

  .flex-1 {
    flex: 1;
  }
}
</style>
